import React, { useEffect } from 'react';
import { useTemperatureStore } from '../store/temperatureStore';
import { useApiData } from '../hooks/useApiData';
import LoadingSkeleton from '../components/LoadingSkeleton';

const TemperaturePage: React.FC = () => {
  const { sensors, setSensors } = useTemperatureStore();
  const { data, isLoading, error } = useApiData();

  useEffect(() => {
    if (data?.temperatures) {
      setSensors(data.temperatures);
    }
  }, [data, setSensors]);

  if (isLoading) {
    return <LoadingSkeleton items={3} itemHeight="h-20" />;
  }

  if (error) {
    return (
      <div className="p-4">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          Error loading temperature data
        </div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Temperature Sensors</h1>
      <div className="grid grid-cols-1 gap-4">
        {sensors.map((sensor) => (
          <div
            key={sensor.id}
            className="bg-white rounded-lg shadow p-4 flex justify-between items-center"
          >
            <div>
              <h2 className="text-lg font-semibold">{sensor.name}</h2>
              <p className="text-gray-500 text-sm">{sensor.location}</p>
            </div>
            <div className="text-2xl font-bold text-blue-500">
              {sensor.temperature}°C
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemperaturePage; 